import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';
import { CreateAuditInformation } from '@store/audits/audits-information/audits-information.model';

interface PreAuditProps {
  updateAuditInformation: (
    field: keyof CreateAuditInformation, value: any
  ) => void;
  auditInformation?: CreateAuditInformation;
  errors: any;
}

const PreAuditNeeds = (props: PreAuditProps) => {

  const { auditInformation, updateAuditInformation, errors } = props;

  const { t } = useTranslation();

  return (
    <>
      <Stack py="24px" pr="10px">
        <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
          <VolunteerActivismIcon sx={{ backgroundColor: '#F5BE55', borderRadius: '2px', width: '25px', color: 'white' }} />
          <Typography fontSize={24} fontWeight="700">
            {t('audits.preAudit.needs.title')}
          </Typography>
        </Stack>
        <Stack py="24px" pr="10px" spacing={1.5}>
          <TextFieldComponent
            multiline
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            placeholder={t('audits.preAudit.needs.placeholder') + '*'}
            handleChange={(description) => updateAuditInformation('need', { description: description })}
            value={auditInformation?.need?.description ?? ''}
            rows={10}
            error={errors.description}
            required={true}
          />
          <Divider variant="fullWidth" orientation="horizontal" />
        </Stack>
      </Stack>
    </>
  );
};

export default PreAuditNeeds;
